import styled from "styled-components";
import { Attribute, AttributeGroup, AttributeProperty, ComponentProps } from "react-builder";
import {
  LessonsElearnProvider,
  useLanguage,
  useLevelsData,
  userDataContext,
} from "../../providers/ElearningV2";
import { useContext, useEffect, useState } from "react";
import { ConfigsProvider, ConfigContext } from "react-builder";
import { useProductApi } from "../../custom-hooks/useProductApi";
import { ElearnUserData } from "../../types/e-learning-types";

@AttributeGroup({
  title: "LessonsBuilderV2",
  blockName: "LessonsBuilderV2",
  module: "elearning",
  icon: "query",
})
export class LessonsBuilderAttributes extends Attribute {
  @AttributeProperty({ type: "String" })
  chapterId?: string;

  @AttributeProperty({ type: "String" })
  lessonId?: string;

  @AttributeProperty({ type: "String" })
  filterIds?: string;

  @AttributeProperty({ type: "String" })
  limit?: string;
}

function LessonsBuilder(
  props: ComponentProps<LessonsBuilderAttributes> & { filterIds?: string[] }
) {
  const content = useContext(ConfigContext);
  const chapterId = props.attributes.chapterId
    ? content.getContent(props.attributes.chapterId)
    : "";
  const lessonIdFilter = props.attributes.lessonId && content.getContent(props.attributes.lessonId);
  const filterIds = props.attributes.filterIds && content.getContent(props.attributes.filterIds);
  //   console.log("limit", props.attributes.limit);
  const { watchedLessons, likedLessons, updateUserDataArrays } = useContext(userDataContext);
  const userDataAPI = useProductApi<ElearnUserData>();
  const userLanguage = useLanguage();

  const isLiked = (lessonId: string) => {
    if (!likedLessons || !likedLessons.length) return false;
    return !!likedLessons?.find((l) => l == lessonId);
  };
  const isWatched = (lessonId: string) => {
    if (!watchedLessons || !watchedLessons.length) return false;
    return !!watchedLessons?.find((l) => l == lessonId);
  };

  const likeLesson = async (lessonId: string) => {
    try {
      if (!userDataAPI) return;
      const response = await userDataAPI.post(`elearn/ElearnUserData/${lessonId}/liked`);
      console.log("likeLesson response", response);
    } catch (error) {
      console.log("error: ", error);
    }
    updateUserDataArrays("likedLessons", [...likedLessons, lessonId]);
  };
  const unlikeLesson = async (lessonId: string) => {
    try {
      if (!userDataAPI) return;
      const response = await userDataAPI.post(`elearn/ElearnUserData/${lessonId}/unliked`);
      console.log("unlikeLesson response", response);
    } catch (error) {
      console.log("error: ", error);
    }
    const updatedLikedLessons = watchedLessons.filter((id) => id !== lessonId);
    updateUserDataArrays("likedLessons", updatedLikedLessons);
  };

  const setWatched = async (lessonId: string) => {
    try {
      if (!userDataAPI) return;
      const response = await userDataAPI.post(`elearn/ElearnUserData/${lessonId}/watched`);
      console.log("setWatchedData response", response);
      updateUserDataArrays("watchedLessons", response.watchedLessons);
    } catch (error) {
      console.log("error: ", error);
    }
  };

  return (
    <LessonsElearnProvider {...props} chapterId={chapterId} loader={<></>}>
      {(lessons) => {
        if (filterIds?.length) {
          lessons = lessons?.filter((l) => filterIds.includes(l._id));
          console.log("filtered ids : ", filterIds, "filtered lessons : ", lessons);
        }

        return (
          <>
            <ConfigsProvider
              configJson={{
                lessons: lessons
                  ?.filter((l) => !lessonIdFilter || l._id == lessonIdFilter)
                  .slice(
                    0,
                    props.attributes.limit ? parseInt(props.attributes.limit) : lessons?.length
                  )
                  .map((l) => {
                    const translationKey = l.translations[userLanguage] ? userLanguage : "EN";
                    const translation = l.translations[translationKey];
                    return {
                      ...l,
                      chapterId: parseInt(l.elearnChapter, 16),
                      chapterOrder: l.chapterOrder,
                      descriptionVideo: translation.translatedDescriptionVideo || "",
                      id: l._id,
                      name: translation.translatedName || "",
                      thumb: l.thumb ? l.thumb.url : null,
                      title: translation.translatedTitle || "",
                      videoUrl: l.video.url || "",
                      isWatched: isWatched(l._id),
                      isLiked: isLiked(l._id),
                      setWatched: () => setWatched(l._id),
                      like: () => likeLesson(l._id),
                      unlike: () => unlikeLesson(l._id),
                    };
                  }),
              }}
            >
              <>{props.children}</>
            </ConfigsProvider>
          </>
        );
      }}
    </LessonsElearnProvider>
  );
}

LessonsBuilder.prototype.Props = LessonsBuilderAttributes;

export default LessonsBuilder;
